import React from "react";
import Skeleton from "./Skeleton";

const UserRowSkeleton = () => (
  <div className="user-row" style={{ pointerEvents: "none" }}>
    <div className="td">
      <div className="user-info">
        <Skeleton
          variant="card"
          width={34}
          height={34}
          borderRadius="50%"
          style={{ flexShrink: 0 }}
        />
        <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
          <Skeleton width={120} height={13} />
          <Skeleton width={160} height={11} />
        </div>
      </div>
    </div>

    <div className="td">
      <Skeleton width={90} height={22} borderRadius={20} />
    </div>

    <div className="td company-cell">
      <Skeleton width={110} height={13} />
    </div>

    <div className="td" style={{ gap: 6 }}>
      <Skeleton width={70} height={13} />
    </div>

    <div className="td">
      <Skeleton width={80} height={22} borderRadius={4} />
    </div>

    <div className="td row-actions">
      <Skeleton width={40} height={28} borderRadius={6} />
    </div>
  </div>
);

export default UserRowSkeleton;
